// import parsePhoneNumber from 'libphonenumber-js'
// import parsePhoneNumber from 'libphonenumber-js/max'
import parseMobile from 'libphonenumber-js/mobile'; // import { parsePhoneNumberWithError, ParseError } from 'libphonenumber-js/max'

const productListing = () => {
  //executes in everypage
  jQuery(document).ready(function ($) {
    //NO longer in use as we get the data directly from wordpress.
    // if($('########body.page-template-page-booking-DISCONTINUED').length){
    //     var data = {
    //         action: 'get_services',
    //     };
    //     jQuery.post(my_ajax_object.ajax_url, data, function(response) {
    //         if(response != ''){
    //             var parsed_data = jQuery.parseJSON(response);
    //             $('#booking-services .loading').hide();
    //             var service = getUrlParameter('services');
    //             if(service){
    //                 var s = Number(service);
    //                 bookingData['service_id'] = s;
    //                 console.log('service', s);
    //             }
    //             parsed_data.forEach(function(item){
    //                 var selected = (s === item.id) ? "selected" : " ";
    //                 var active = (s === item.id) ? "active" : " ";
    //                 if(s){
    //                     if(s != item.id){
    //                         var def = "active";
    //                     }
    //                 }else{
    //                     var def = "active";
    //                 }
    //                 var left_col = "";
    //                 if(item.category == 'single'){
    //                     left_col = '<div class="col-left">'+
    //                                     '<span id="duration-text" class="hour">'+item.duration_text+'</span> '+
    //                                     '<span id="amount" class="amount">'+item.currency +'$ '+item.price+'</span> '+
    //                                     '<span>'+$('#per-person-text').text()+'</span>'+
    //                                 '</div>';
    //                 }
    //                 var h = '<div class="service-step-container '+selected+'">'+
    //                             '<div class="top-section">'+
    //                                 '<div class="col-left">'+
    //                                     '<h3 id="service-name">'+item.name+'</h3>'+
    //                                 '</div>'+
    //                                 '<div class="col-right">'+
    //                                     '<h5 class="view-details '+def+'">'+$('#view-details-text').text()+'</h5>'+
    //                                     '<h5 class="hide-details '+active+'">'+$('#hide-details-text').text()+'</h5>'+
    //                                 '</div>'+
    //                             '</div>'+
    //                             '<div class="middle-section">'+
    //                                 left_col+
    //                             '</div>'+
    //                             '<div class="h-line"></div>'+
    //                             '<div class="mobile-view-details">'+
    //                                 '<div class="h-line2"></div>'+
    //                                 '<h5 class="view-details '+def+'"">'+$('#view-details-text').text()+'</h5>'+
    //                                 '<h5 class="hide-details '+active+'">'+$('#hide-details-text').text()+'</h5>'+
    //                             '</div>'+
    //                             '<div class="button-section">'+
    //                                 '<div class="select-btn btn2 '+selected+'" data-id='+item.id+' data-price="'+item.price+'" data-amount="'+item.currency +'$ '+item.price+'" data-category="'+item.category+'">'+$('#select-text').text()+'</div>'+
    //                             '</div>'+
    //                             '<div class="details-section '+active+'">'+
    //                                 '<p>'+item.description+'</p>'+
    //                             '</div>'+
    //                         '</div>';
    //                 $('#booking-services').append(h);
    //             });
    //         }
    //     });
    // }
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    }; // if($('body.page-template-page-booking').length){


    window.get_locations = function () {
      $('#step-2-container .loading').show();
      $('#location-services').empty();
      var data = {
        action: 'get_locations',
        service_id: bookingData.service_id
      };
      jQuery.post(my_ajax_object.ajax_url, data, function (response) {
        if (response != '') {
          var parsed_data = jQuery.parseJSON(response);
          $('#step-2-container .loading').hide();
          parsed_data.data.forEach(function (item) {
            var description = "<div>" + item.description + "</div>";
            var desc = $("<div>").html(description).text();
            var options = "";

            if (bookingData.service_category == "single") {
              var i = 1;
              var max = item.qty + 1; //single service (max 4 [5])
            } else {
              var i = 5;
              var max = 13; //party service (max 12 [13])
            } // for(i; i < item.qty + 1; i++){


            for (i; i < max; i++) {
              var o = '<option value="' + i + '">' + i + '</option>';
              options += o;
            }

            var h = '<div class="service-step-container">' + '<div class="top-section">' + '<div class="col-left">' + '<h3>' + item.name + '</h3>' + '</div>' + '<div class="col-right">' + '</div>' + '</div>' + '<div class="middle-section">' + '<div class="col-left">' + '<p>' + item.description + '</p>' + '</div>' + '<div class="col-right">' + '<div class="quantity quantity-input">' + `${$('#how-many-people-text').text()} ` + ` (max ${max - 1} guests)*` + // `<select class="guest-count"><option value="0">0</option>'${options}'</select>` +
            `
                                                        <div class="custom-qty-input">
                                                            <a href="javascript:void(0)" class="product-minus-qty">
                                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g clip-path="url(#clip0_2212_2029)">
                                                                        <path d="M11.25 9.5625C11.5606 9.5625 11.8125 9.31065 11.8125 9C11.8125 8.68935 11.5606 8.4375 11.25 8.4375H6.75C6.43934 8.4375 6.1875 8.68935 6.1875 9C6.1875 9.31065 6.43934 9.5625 6.75 9.5625H11.25Z" fill="#C88BDC"/>
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM2.0625 9C2.0625 5.16853 5.16853 2.0625 9 2.0625C12.8314 2.0625 15.9375 5.16853 15.9375 9C15.9375 12.8314 12.8314 15.9375 9 15.9375C5.16853 15.9375 2.0625 12.8314 2.0625 9Z" fill="#C88BDC"/>
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_2212_2029">
                                                                            <rect width="18" height="18" fill="white"/>
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </a>
                                                            <input class="cstm-qty guest_count" type="number" min="0" max="${max - 1}" value="0">
                                                            <a href="javascript:void(0)" class="product-add-qty">
                                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g clip-path="url(#clip0_2212_2033)">
                                                                        <path d="M9.5625 6.75C9.5625 6.43934 9.31065 6.1875 9 6.1875C8.68935 6.1875 8.4375 6.43934 8.4375 6.75V8.4375H6.75C6.43934 8.4375 6.1875 8.68935 6.1875 9C6.1875 9.31065 6.43934 9.5625 6.75 9.5625H8.4375V11.25C8.4375 11.5606 8.68935 11.8125 9 11.8125C9.31065 11.8125 9.5625 11.5606 9.5625 11.25V9.5625H11.25C11.5606 9.5625 11.8125 9.31065 11.8125 9C11.8125 8.68935 11.5606 8.4375 11.25 8.4375H9.5625V6.75Z" fill="#C88BDC"/>
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM2.0625 9C2.0625 5.16853 5.16853 2.0625 9 2.0625C12.8314 2.0625 15.9375 5.16853 15.9375 9C15.9375 12.8314 12.8314 15.9375 9 15.9375C5.16853 15.9375 2.0625 12.8314 2.0625 9Z" fill="#C88BDC"/>
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_2212_2033">
                                                                            <rect width="18" height="18" fill="white"/>
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    ` + '</div>' + '<div class="button-section">' + '<div class="select-btn btn2" data-id="' + item.id + '" data-location="' + item.name + '">' + $('#select-text').text() + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="h-line"></div>' + '</div>';
            $('#location-services').append(h);
          });
        }
      });
    };

    $('#datepicker').on('change', function () {
      var booking_date = $(this).val();
      bookingData['booking_date'] = booking_date;
      get_timeslots();
    });

    window.get_timeslots = function () {
      // $('#timeslotplaceholder').show();
      $('#timeslot-services .loading').show();
      $('.date-picker-container').hide();
      $('#timeslots-content').empty(); //date format is yyyy/mm/dd for API

      var data = {
        action: 'get_timeslots',
        booking_date: bookingData.booking_date,
        service_id: bookingData.service_id,
        //should get the id of selected service
        provider_id: bookingData.provider_id,
        //should get the id of selected provider (location)
        count: bookingData.count //number of members

      };
      jQuery.post(my_ajax_object.ajax_url, data, function (response) {
        var parsed_data = jQuery.parseJSON(response);

        if (parsed_data.length) {
          $('#timeslot-services .loading').hide();
          $('.date-picker-container').show();
          $('#timeslotplaceholder').hide();
          parsed_data.forEach(function (item) {
            var time = convert_time(item.time);
            var h = '<div class="time-wrapper" data-id=' + item.time + '>' + time + '</div>';
            $('#timeslots-content').append(h);
          });
        } else {
          $('.date-picker-container').show();
          $('#timeslotplaceholder').show();
          $('#timeslot-services .loading').hide();
        }
      });
    };

    function convert_time(starttime) {
      var time = starttime.split(":"),
          h = +time[0],
          p;

      if (h >= 12) {
        if (h > 12) {
          h -= 12;
        }

        p = " PM";
      } else {
        h = h || 12;
        p = " AM";
      } // if(h >= 12){
      //     p = " PM";
      // }else{
      //     p = " AM";
      // }


      var t = h + ":" + time[1] + p;
      return t;
    }

    $('body').on('click', '#book-now-final', function (e) {
      // if($('#term-checkbox').prop("checked") != true){
      //     alert('Please agree to terms and conditions');
      // }
      if (!$('#term-checkbox').is(':checked')) {
        alert('Please agree to terms and conditions');
        return false;
      }

      var validate = validate_form();

      if (validate == "false") {
        return false;
      }

      var primary_client_name_error = '';

      if (!isAllLetter($('#client-firstname').val())) {
        var parent = $('#client-firstname').parents('.half-input');
        $(parent).addClass('required');
        primary_client_name_error += '- First name should only contain english letters or chinese characters'; // return false;
      } else {
        var parent = $('#client-firstname').parents('.half-input');
        $(parent).removeClass('required');
      }

      if (!isAllLetter($('#client-lastname').val())) {
        var parent = $('#client-lastname').parents('.half-input');
        $(parent).addClass('required'); // primary_client_name_error += '- Last name should only contain english letters or chinese characters';

        if (primary_client_name_error != '') {
          primary_client_name_error += '\r\n- Last name should only contain english letters or chinese characters';
        } else {
          primary_client_name_error += '- Last name should only contain english letters or chinese characters';
        } // return false;

      } else {
        var parent = $('#client-lastname').parents('.half-input');
        $(parent).removeClass('required');
      }

      if (primary_client_name_error != '') {
        alert(primary_client_name_error);
        return false;
      }

      if ($('#client-phone').val() != '') {
        var client_phone_trimmed = $('#client-phone').val().trim(); // var client_phone_trimmed = parseMobile(client_phone_trimmed);
        // alert(client_phone_trimmed);
        // if(client_phone_trimmed.length < 8 || client_phone_trimmed.indexOf('+') != 0 || !$.isNumeric(client_phone_trimmed)){

        if (client_phone_trimmed) {
          // if(!client_phone_trimmed.isValid()){
          //     alert('Phone number is invalid! note: the number has to be in full format with country code (example:+85212345678)');
          //     var parent = $('#git push client-phone').parents('.half-input');
          //     $(parent).addClass('required');
          //     return false;
          // }else{
          var parent = $('#client-phone').parents('.half-input');
          $(parent).removeClass('required'); // }
        } else {
          // alert('Phone number is invalid \r\nnote: the number has to be in full format with country code (example:+85212345678)');
          alert('Phone number is invalid');
          var parent = $('#client-phone').parents('.half-input');
          $(parent).addClass('required');
          return false;
        }
      } else {
        alert('Phone number is required');
        var parent = $('#client-phone').parents('.half-input');
        $(parent).addClass('required');
        return false;
      }

      if ($('#client-email').val() != '') {
        var client_email_trimmed = $('#client-email').val().trim();

        if (IsEmail(client_email_trimmed) == false) {
          // $('#invalid_email').show();
          alert('Please provide a valid email');
          var parent = $('#client-email').parents('.half-input');
          $(parent).addClass('required');
          return false;
        } else {
          var parent = $('#client-email').parents('.half-input');
          $(parent).removeClass('required');
        }
      }

      var guest_name_issue = false;
      $('input.guest-firstname').each(function () {
        // $.each($('input.guest-phone'),function(){
        // $('input.guest-phone').each((index, element) => {
        if ($(this).val() != '') {
          var name = $(this).val().trim();

          if (isAllLetter(name) == false) {
            // alert('Phone number has to be in full format with country code (example:+85212345678)');
            var parent = $(this).parents('.half-input');
            $(parent).addClass('required');
            guest_name_issue = true;
          } else {
            var parent = $(this).parents('.half-input');
            $(parent).removeClass('required');
          }
        }
      }); // var guest_name_issue = false;

      $('input.guest-lastname').each(function () {
        // $.each($('input.guest-phone'),function(){
        // $('input.guest-phone').each((index, element) => {
        if ($(this).val() != '') {
          var name = $(this).val().trim();

          if (isAllLetter(name) == false) {
            // alert('Phone number has to be in full format with country code (example:+85212345678)');
            var parent = $(this).parents('.half-input');
            $(parent).addClass('required');
            guest_name_issue = true;
          } else {
            var parent = $(this).parents('.half-input');
            $(parent).removeClass('required');
          }
        }
      });
      var guest_number_issue = false;
      $('#guest-form-container input.guest-phone').each(function () {
        // $.each($('input.guest-phone'),function(){
        // $('input.guest-phone').each((index, element) => {
        if ($(this).val() != '') {
          var phone_trimmed = $(this).val().trim(); // console.log('guest number: ',phone_trimmed);
          // var phone_trimmed = parseMobile(phone_trimmed);

          if (phone_trimmed) {
            // if(!phone_trimmed.isValid()){
            //     // alert('Phone number has to be in full format with country code (example:+85212345678)');
            //     var parent = $(this).parents('.half-input');
            //     $(parent).addClass('required');
            //     guest_number_issue = true;
            // }else{
            var parent = $(this).parents('.half-input');
            $(parent).removeClass('required');
            guest_number_issue = false; // }
          } else {
            var parent = $(this).parents('.half-input');
            $(parent).addClass('required');
            guest_number_issue = true;
          }
        }
      });
      var guest_email_issue = false;
      $('input.guest-email').each(function () {
        // $.each($('input.guest-phone'),function(){
        // $('input.guest-phone').each((index, element) => {
        if ($(this).val() != '') {
          var email_trimmed = $(this).val().trim();

          if (IsEmail(email_trimmed) == false) {
            // alert('Phone number has to be in full format with country code (example:+85212345678)');
            var parent = $(this).parents('.half-input');
            $(parent).addClass('required');
            guest_email_issue = true;
          } else {
            var parent = $(this).parents('.half-input');
            $(parent).removeClass('required');
          }
        }
      });
      var error_msg = '';

      if (guest_name_issue) {
        error_msg += '- First name / Last name should only contain english letters or chinese characters';
      }

      if (guest_number_issue) {
        // alert('Invalid telephone number for guest(s)');
        if (error_msg != '') {
          error_msg += '\r\n- Invalid telephone number for guest(s)';
        } else {
          error_msg += '- Invalid telephone number for guest(s)';
        } // return false;

      }

      if (guest_email_issue) {
        // alert('Please provide a valid email for guest(s)');
        if (error_msg != '') {
          error_msg += '\r\n- Please provide a valid email for guest(s)';
        } else {
          error_msg += '- Please provide a valid email for guest(s)';
        } // return false;

      }

      if (error_msg != '') {
        alert(error_msg);
        return false;
      }

      $(this).addClass('loading'); // alert('booking...');
      // step 1: check again if time slot has enough seats for booking
      // step 2: check if user has been already booked before
      // step 3: proceed to complete the booking

      var booking_date = bookingData.booking_date;
      var booking_time = bookingData.time;
      var start_datetime = booking_date + ' ' + booking_time;
      var provider_id = bookingData.provider_id;
      var service_id = bookingData.service_id;
      var total_count = bookingData.count;
      var occasion = bookingData.occasion;
      var primary_user = {
        "first_name": $('#client-firstname').val(),
        "last_name": $('#client-lastname').val(),
        "telephone_number": $('#client-phone').val(),
        "email": $('#client-email').val(),
        "birth_date": $('#client-birthdate').val() //format: dd-mm-yyyy

      };
      var clientname = $('#client-firstname').val() + ' ' + $('#client-lastname').val();

      if (bookingData.category == 'single') {
        var htm = 'Guest 1'; // var  htm = '<h3>Guest 1</h3>'+client;
      } else {
        var htm = $('#my-information-text').text(); // var  htm = '<h3>'+$('#my-information-text').text()+'</h3>'+client;
      }

      $('#client-info-template-modified .guest-counter-heading').text(htm);
      $('#client-info-template-modified .confirm-name-value').text(clientname);
      $('#client-info-template-modified .confirm-phone-value').text($('#client-phone').val());
      $('#client-info-template-modified .confirm-email-value').text($('#client-email').val());
      $('#client-info-template-modified .confirm-birthdate-value').text($('#client-birthdate').val());
      var clientHTM = $('#client-info-template-modified').html();
      $('#guest-info-container').prepend(clientHTM);
      bookingData['client_message'] = $('#client-message').val();
      var guests = [];
      var guests_data = $('#guest-form-container');
      var count = 1;
      $('.guest-form', guests_data).each(function (index) {
        count++;
        var guest = {
          "first_name": $('.guest-firstname', this).val(),
          "last_name": $('.guest-lastname', this).val(),
          "telephone_number": $('.guest-phone', this).val(),
          "email": $('.guest-email', this).val()
        };
        guests.push(guest);
        console.log(guest);
        console.log('before category', bookingData);

        if (bookingData.category == 'single') {
          var name = $('.guest-firstname', this).val() + ' ' + $('.guest-lastname', this).val();
          $('#guest-info-template-modified .guest-counter-heading').text(`Guest ${count}`);
          $('#guest-info-template-modified .confirm-name-value').text(name);
          $('#guest-info-template-modified .confirm-phone-value').text($('.guest-phone', this).val());
          $('#guest-info-template-modified .confirm-email-value').text($('.guest-email', this).val());
          var h = $('#guest-info-template-modified').html(); // console.log( 'guestinfo', h );
          // var ht = '<h3>Guest '+count+'</h3>'+h;

          $('#guest-info-container').append(h);
        }
      });
      bookingData['primary_user'] = primary_user;
      bookingData['guests'] = guests;
      console.log(bookingData); // var primary_user = {
      //     "first_name" : "Cristiano",
      //     "last_name" : "ronaldo",
      //     "telephone_number": "+85256568787",
      //     "email": "cristianoronaldo@gmail.com",
      //     "birth_date": "", //format: dd-mm-yyyy
      // };
      // var guests = [
      //     {
      //         "first_name": "Lionel",
      //         "last_name": "Messi",
      //         "telephone_number": "+85265478903",
      //         "email": 'messi@gmail.com'
      //     },
      //     {
      //         "first_name": "Mohamed",
      //         "last_name": "Salah",
      //         "telephone_number": "+85262345678",
      //         "email": 'mohamedsaleh@gmail.com'
      //     }
      // ];
      // var final_slot_check_data = {
      //     action: 'final_slot_check',
      //     'service_type': bookingData.category,
      //     'total_count' : total_count,
      //     'start_datetime': start_datetime,
      //     'service_id': service_id, //should get the id of selected service
      //     'provider_id': provider_id, //should get the id of selected provider (location)
      //     'primary_user': primary_user,
      //     'guests': guests,
      // };
      // jQuery.post(my_ajax_object.ajax_url,final_slot_check_data, function(res){
      // console.log('checking availability');
      // console.log('available?', res);
      // if(res == "full"){
      //     alert('the timeslots are full');
      //     $('#book-now-final').removeClass('loading');
      // }else if(res == "none"){
      //     alert('no timeslots available');
      //     $('#book-now-final').removeClass('loading');
      // } else {
      //proceed to booking
      // alert('can proceed to book');
      //check if any of the user has already booked
      // var check_already_booked_data = {
      //     'action': 'check_if_user_has_already_booked',
      //     'start_datetime': start_datetime,
      //     'service_id': service_id, //should get the id of selected service
      //     'provider_id': provider_id,
      //     'primary_user': primary_user,
      //     'total_count': total_count,
      //     'guests': guests,
      // }
      // jQuery.post(my_ajax_object.ajax_url,check_already_booked_data, function(response_data){
      // console.log('booking data', response_data);
      // var parsed_response_data = jQuery.parseJSON(response_data);
      // if(parsed_response_data.status == "exists"){
      //     var msg = '';
      //     msg += parsed_response_data.message + '\n';
      //     parsed_response_data.users.forEach(function(item){
      //         msg += item+ '\n';
      //     });
      //     alert(msg);
      // } else {

      console.log('can proceed to booking!!!');
      var data = {
        action: 'book_service',
        'service_type': bookingData.category,
        //single or party
        'total_count': total_count,
        'start_datetime': start_datetime,
        'service_id': service_id,
        //should get the id of selected service
        'provider_id': provider_id,
        //should get the id of selected provider (location)
        'primary_user': primary_user,
        'message': $('#client-message').val(),
        'promotion_code': $('#client-promotion-code').val(),
        'guests': guests,
        'occasion': occasion
      }; // var promocode = $('#client-promotion-code').val().trim();
      // after update

      var promocode = '';
      jQuery.post(my_ajax_object.ajax_url, data, function (response) {
        console.log('book service ajax triggered');
        console.log(response);
        var parsed_booking_response_data = jQuery.parseJSON(response);

        if (response != '') {
          console.log(response);

          if (parsed_booking_response_data.primary_boooking_code) {
            console.log('primary booking code exists');
            console.log(parsed_booking_response_data.primary_boooking_code);

            if (promocode && promocode != '') {
              //if promo code is provided
              // var promo_data = {
              //     action: 'apply_promo',
              //     'promo_code': promocode,
              //     'booking_code': parsed_booking_response_data.primary_boooking_code,
              //     'booking_id': parsed_booking_response_data.primary_booking_id
              // };
              //get invoice id first to apply promocode
              var invoice_data = {
                action: 'get_invoice',
                'booking_code': parsed_booking_response_data.primary_boooking_code
              };
              jQuery.post(my_ajax_object.ajax_url, invoice_data, function (invoice_response) {
                console.log('getting booking invoice data');
                console.log(invoice_response); // var parsed_booking_response_data = jQuery.parseJSON(response);

                var parsed_invoice = jQuery.parseJSON(invoice_response);

                if (invoice_response != '') {
                  console.log('invoice id is: ', parsed_invoice.data[0].id);
                  console.log('invoice number is: ', parsed_invoice.data[0].number);

                  if (!parsed_invoice.data[0].id) {
                    alert('error: failed to get invoice id');
                  } else {
                    var promo_data = {
                      action: 'apply_promo',
                      'promo_code': promocode,
                      'order_id': parsed_invoice.data[0].id
                    };
                    jQuery.post(my_ajax_object.ajax_url, promo_data, function (promo_response) {
                      // console.log('promo response: ',promo_response);
                      if (promo_response != '') {
                        console.log('apply promo response', promo_response);
                        var decoded_promo = jQuery.parseJSON(promo_response);

                        if (decoded_promo.code) {
                          //when apply promo fails
                          alert(decoded_promo.message);
                          fill_confirmation(response);
                        } else {
                          console.log('promo client name:', decoded_promo.client.name);
                          console.log('total discounted amount:', decoded_promo.discount_amount);
                          bookingData['promo'] = promocode;
                          bookingData['total_discount'] = decoded_promo.discount_amount;
                          fill_confirmation(response); // fbq('trackCustom', 'BookNow');

                          if (check_env() == 'live') {
                            // fbq('track', 'Lead');
                            // fbq('track', 'Lead',{eventID: 'Lead_id'});
                            // fbq('track', 'Lead', {}, {fbp: getFbqCookie(), eventID: eventID});
                            var rndNum = getRandomNumbers(1, 100000);
                            var eventID = 'Lead' + rndNum;
                            fbq('track', 'Lead', {}, {
                              eventID: eventID
                            });
                            console.log('form submission fb pixel lead event sent!');
                            var data = {
                              action: 'send_fb_conversion',
                              event_name: 'Lead',
                              event_id: eventID
                            };
                            jQuery.post(my_ajax_object.ajax_url, data, function (response) {
                              console.log('send_fb_conversion is called: ');
                              console.log(response);
                              var parsed_response = JSON.parse(response);
                              console.log(parsed_response);

                              if (parsed_response.status == "failed") {
                                // alert(parsed_response['errors'][0]);
                                console.log(parsed_response['errors'][0]);
                              }
                            });
                          }
                        }
                      } else {
                        console.log('no promo response');
                      }
                    });
                  }
                }
              });
            } else {
              //no promo code go to confirmation
              fill_confirmation(response); // fbq('trackCustom', 'BookNow');

              if (check_env() == 'live') {
                // fbq('track', 'Lead',{eventID: 'Lead_id'});
                // fbq('track', 'Lead', {} ,{fbp: getFbqCookie(), eventID: eventID});
                var rndNum = getRandomNumbers(1, 100000);
                var eventID = 'Lead' + rndNum;
                fbq('track', 'Lead', {}, {
                  eventID: eventID
                });
                console.log('form submission fb pixel lead event sent!');
                var data = {
                  action: 'send_fb_conversion',
                  event_name: 'Lead',
                  event_id: eventID
                };
                jQuery.post(my_ajax_object.ajax_url, data, function (response) {
                  console.log('send_fb_conversion is called: ');
                  console.log(response);
                  var parsed_response = JSON.parse(response);
                  console.log(parsed_response);

                  if (parsed_response.status == "failed") {
                    // alert(parsed_response['errors'][0]);
                    console.log(parsed_response['errors'][0]);
                  }
                });
              }
            }
          } else {
            //no booking code returned (booking failed)
            alert(response);
          }
        } else {
          // console.log('no response ');
          alert('failed to book!');
        }
      }); // }
      // }); //check if user has already booked
      // }
      // })
    });

    function IsEmail(email) {
      var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

      if (!regex.test(email)) {
        return false;
      } else {
        return true;
      }
    }

    function isAllLetter(inputtxt) {
      // var letters = /^[A-Za-z ]+$/;
      //allow only english letters, chinese characters and space
      var letters = /^[A-Za-z\u3000\u3400-\u4DBF\u4E00-\u9FFF ]+$/; // var letters = \u4e00-\u9fa5_a-zA-Z;

      if (inputtxt.match(letters)) {
        return true;
      } else {
        return false;
      }
    } //


    if ($('.page-template-page-cancel-booking').length) {
      // alert('on cancel booking page!');
      $('.page-template-page-cancel-booking a.cancel-booking').on('click', function (e) {
        e.preventDefault(); // alert('confirming the cancel button');

        if ($('#cancel-booking-code').val() != '') {
          // if($('#primary-booking-id').val() != ''){
          $('div.custom-loading').removeClass('hide');
          $('div.cancel-content').addClass('hide');
          var booking_code = $('#cancel-booking-code').val(); // var booking_category = $('#cancel-booking-category').val();
          // var primary_booking_id = $('#primary-booking-id').val();
          // alert('the booking code is '+booking_code);

          var ajax_data = {
            action: 'cancel_booking',
            'booking-code': booking_code // 'booking-category':booking_category
            // 'primary-booking-id':primary_booking_id

          };
          jQuery.post(my_ajax_object.ajax_url, ajax_data, function (bookingInfo) {
            console.log(bookingInfo);

            if (bookingInfo == 'not_found') {
              $('div.custom-loading').addClass('hide');
              alert('Booking is not found, please check your booking code');
            } else if (bookingInfo == 'failed') {
              $('div.custom-loading').addClass('hide');
              alert('Failed to delete the booking, please contact us at 2671 1288');
            } else if (bookingInfo == 'guest') {
              $('div.custom-loading').addClass('hide'); // alert('Guest is not allowed to cancel booking');

              alert("Only main guest is allowed to cancel the booking. Please cancel the booking from the main guest's email or call 2671 1288 for a change of booking.\n請經由主要預約人之電郵取消預約，亦歡迎致電 2671 1288 更改預約，謝謝。");
            } else if (bookingInfo == 'cancelled_successfully') {
              $('div.custom-loading').addClass('hide'); // alert('your booking has been successfully cancelled');

              alert("Your booking has been successfully canceled, hope to see you next time! \n您已成功取消預約，期待下次再與您見面，謝謝！"); // var bookingDetails = JSON.parse(bookingInfo);
              // console.log('booking is found and the booking id is',bookingDetails.booking_id);
              // $('div.cancel-content').removeClass('hide');

              var home = $('#home_url').val();
              window.location.href = home;
            } else {
              $('div.custom-loading').addClass('hide');
              alert(bookingInfo); // window.location.href = home;
            }
          }); // }else{
          //     alert('- Guest is not allowed to cancel booking');
          // }
        } else {
          alert('- Booking code is required!');
        }
      });
    } // $('#section1 .btn-container .btn, #section2 .slick-slide .btn-container .btn, #section3 .btn-container .btn, #section4 .btn-container .btn, .header__logo a, #footer-section2 .col1 li a').on('click',function(e){
    //     e.preventDefault();
    //     alert('testing, works!!');
    //     console.log('testing home page click trigger');
    //     if(check_env() == 'live'){
    //         // e.preventDefault();
    //         // alert('testing, workss!!');
    //         // fbq('track', 'ViewContent');
    //         // fbq('track', 'ViewContent',{eventID: 'ViewContent_id'});
    //         var rndNum = getRandomNumbers(1,100000);
    //         var eventID = 'ViewContent'+rndNum;
    //         // fbq('track', 'ViewContent', {}, {fbp: getFbqCookie(), eventID: eventID});
    //         fbq('track', 'ViewContent', {}, {eventID: eventID});
    //         console.log('fb pixel browser viewcontent event is sent!');
    //         var data = {
    //             action: 'send_fb_conversion',
    //             event_name: 'ViewContent',
    //             event_id:  eventID
    //         };
    //         //trigger thee event
    //         jQuery.post(my_ajax_object.ajax_url, data, function(response) {
    //             console.log('send_fb_conversion is called: ');
    //             console.log(response);
    //             var parsed_response = JSON.parse(response);
    //             console.log(parsed_response);
    //             if(parsed_response.status == "failed"){
    //                 // alert(parsed_response['errors'][0]);
    //                 console.log(parsed_response['errors'][0]);
    //             }
    //         });
    //     }
    // });


    if ($('body.home').length || $('body.page-booking').length) {
      //send fb viewcontent pixel event, everytime user lands on the booking page/ home page
      if (check_env() == 'live') {
        // e.preventDefault();
        // alert('testing, workss!!');
        // fbq('track', 'ViewContent');
        // fbq('track', 'ViewContent',{eventID: 'ViewContent_id'});
        var rndNum = getRandomNumbers(1, 100000);
        var eventID = 'ViewContent' + rndNum; // fbq('track', 'ViewContent', {}, {fbp: getFbqCookie(), eventID: eventID});

        fbq('track', 'ViewContent', {}, {
          eventID: eventID
        });
        console.log('fb pixel browser viewcontent event is sent!');
        var data = {
          action: 'send_fb_conversion',
          event_name: 'ViewContent',
          event_id: eventID
        }; //trigger thee event

        jQuery.post(my_ajax_object.ajax_url, data, function (response) {
          console.log('send_fb_conversion is called: ');
          console.log(response);
          var parsed_response = JSON.parse(response);
          console.log(parsed_response);

          if (parsed_response.status == "failed") {
            // alert(parsed_response['errors'][0]);
            console.log(parsed_response['errors'][0]);
          } else {
            console.log('fb pixel server viewcontent event is sent!');
            console.log('-');
          }
        });
      }
    } // if($('body.home').length || $('body.page-booking').length){
    //     // alert('on home page!');
    //     //for PageView
    //     if(check_env() == 'live'){
    //         // var data = {
    //         //     action: 'send_fb_conversion',
    //         //     event_name: 'PageView'
    //         // };
    //         // jQuery.post(my_ajax_object.ajax_url, data, function(response) {
    //         //     console.log('send_fb_conversion is called: ');
    //         //     console.log(response);
    //         //     var parsed_response = JSON.parse(response);
    //         //     console.log(parsed_response);
    //         //     if(parsed_response.status == "failed"){
    //         //         // alert(parsed_response['errors'][0]);
    //         //         console.log(parsed_response['errors'][0]);
    //         //     }
    //         // });
    //     }
    // }


    if ($('body').length) {
      // alert('body exists!');
      var _fbq = getFbqCookie();

      console.log('facebook fbq cookie: ', _fbq);
      console.log('all cookies');
      console.log($.cookie());
      console.log('hubspot cookie', $.cookie("hubspotutk"));
      console.log('fbp cookie', $.cookie("_fbp"));
      console.log(getRandomNumbers(1, 100000));
    }

    function getFbqCookie() {
      if ($.cookie("_fbp") != '') {
        var fbq_cookie = $.cookie('_fbp');
      } else {
        var fbq_cookie = '';
      }

      return fbq_cookie;
    }

    function getRandomNumbers(min, max) {
      // return $.randomBetween(min,max);
      var random = Math.floor(Math.random() * (max - min + 1)) + min;
      return random;
    }
  });

  function check_env() {
    var origin = window.location.origin;

    if (origin.indexOf("local") >= 0) {
      return 'local';
    } else if (origin.indexOf("wecreatelabs") >= 0) {
      return 'dev';
    } else {
      return 'live';
    }
  }
};

export default productListing;